import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-molecular-blade',
  templateUrl: './molecular-blade.component.html',
  styleUrls: ['./molecular-blade.component.css']
})
export class MolecularBladeComponent implements OnInit {

  constructor(public api: ApiService) { }

  public title: string;

  ngOnInit() {

    // if(this.model.Groups.length > 0)
    //   return;
    //this.addNewGroup();
  }

  addNewGroup() {
    console.log('addNewGroup()');

    let group = { MatchAll: true, MolecularCriterias: [] };
    this.addCriteriaToGroup(group);
    this.model.Groups.push(group);
  }

  get isDevEnvironment() {
    return location.hostname === "localhost";
  }

  addCriteriaToGroup(group) {
    console.log('addCriteriaToGroup(...)');

    let criteria = {};
    group.MolecularCriterias.push(criteria);
  }

  deleteGroup(group) {
    let index = this.model.Groups.indexOf(group);
    console.log('index of group to delete: ' + index);
    this.model.Groups.splice(index, 1);
  }

  deleteCriteria(group, criteria) {
    let index = group.MolecularCriterias.indexOf(criteria);
    group.MolecularCriterias.splice(index, 1);
    if(group.MolecularCriterias.length < 1)
      this.deleteGroup(group);
  }

  get model() {
    return this.api.session.currentCriteria.MolecularCriteria;
  }

  debug: string;
  doDebug() {
    this.debug = JSON.stringify(this.model);
  }

  setMatchAllGroups(value) {
    this.model.MatchAllGroups = value;
  }

  clearCurrent(){
    this.model.Groups = [];
  }
  //={
  //   MatchAllGroups:false,
  //   Groups:[
  //     // {MatchAll:true, MolecularCriterias:[]}
  //     ]
  // };
}
